<template>
  <div class="home">

   <progressDialog v-bind:loadingContent="loadingContent" />

   <v-data-table
      :headers="headers"
      :items="ruleGroups"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [15]
      }"
      loading-text="Carregando"
      :loading="loadingSearchData"
      :options.sync="searchPagination"
      :server-items-length.sync="searchPagination.totalItems"
      @update:page="searchDataTableUpdatePage"
    >
      <template v-slot:top>
        <v-toolbar flat color="muted">
          <v-toolbar-title>Grupos de Regras do Drive</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-select :no-data-text="noDataAvailable" label="Papel" v-model="userRoleID" :items="allUserRoles" class="mt-5 pt-1" @change="searchDataTableUpdatePage" item-text="value" item-value="id">
          </v-select>
          <v-spacer></v-spacer>

          <v-text-field
          v-model="searchTerm"
          append-icon="mdi-card-text"
          label="Pesquise pelo nome ou descrição"
          single-line
          hide-details
          @keyup="searchTermChange"
          ></v-text-field>

          <v-btn icon color="primary" v-on:click="newItem">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <DialogItem ref="dialogItem" v-bind:allUserRoles="allUserRoles"
            v-bind:open="openDialogItem"
            v-bind:editedItem="editedItem"
            v-bind:editing="editing"
            v-on:closeDialogItem="closeDialogItem"
            v-on:saveDialogItem="saveDialogItem" />

        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="actions">
          <v-icon small class="mr-2"
                  @click="detailItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2"
            @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2"
            @click="deleteItem(item)">
            mdi-trash-can
          </v-icon>
        </div>
      </template>
     <template v-slot:item.name="{ item }">
       {{item.name}}
     </template>
     <template v-slot:item.description="{ item }">
       {{item.description}}
     </template>
      <template v-slot:item.userRole="{ item }">
        {{getUserRoleDescription(item.userRole)}}
      </template>
      <template v-slot:item.defaults="{ item }">
        <onOffItem v-bind:value="item.defaults" />
      </template>
      <template v-slot:no-data>
        <span v-show="!loadingContent && !loadingError">Não há grupos de regras cadastrados</span>
        <span v-show="loadingError">Ocorreu um erro ao buscar as informações</span>
      </template>
    </v-data-table>

    <DeletionConfirmationModal :open="deleting" :item="deletedItem" @close="stopDeletingItem" @confirm="confirmItemDeletion"/>

  </div>
</template>
<script>
import onOffItem from '@/components/on-off-item/index.vue';
import progressDialog from '@/components/progress-dialog/progressDialog.vue';
import DeletionConfirmationModal from '@/components/deletion-confirmation-modal/index.vue';
import DialogItem from './DialogItem.vue';
import RuleGroupsService from '../../service/RuleGroupsService';

export default {
  name: 'RuleGroups',
  components: {
    DialogItem,
    onOffItem,
    progressDialog,
    DeletionConfirmationModal,
  },

  data: () => ({
    content: [],
    loadingContent: false,
    loadingError: false,
    headers: [
      { text: '', sortable: false, value: 'actions' },
      { text: 'ID', sortable: false, value: 'id' },
      { text: 'Nome', sortable: false, value: 'name' },
      { text: 'Descrição', sortable: false, value: 'description' },
      { text: 'Papel do Usuário', sortable: false, value: 'userRole' },
      { text: 'Padrão', sortable: false, value: 'defaults' },
    ],
    ruleGroups: [],
    userRoleID: '',
    allUserRoles: [
      { id: 'COMPANY', value: 'Empresa' },
      { id: 'BENEFICIARY', value: 'Beneficiário' },
      { id: 'BACKOFFICE', value: 'Backoffice' },
      { id: 'BROKER', value: 'Broker' },
      { id: 'EU_PROTEGIDO', value: 'Eu protegido' },
      { id: 'DOCTOR', value: 'Dr Protegido' },
    ],
    loadingSearchData: false,
    searchPagination: {
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
    },
    searchTerm: '',

    openDialogItem: false,
    editedItem: {},
    editing: false,
    openDialogNewSort: false,
    selectedItemSort: {},
    deletedItem: {},
    deleting: false,
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.userRoleID = this.allUserRoles[0].id;
      this.loadRuleGroupsPage();
    },
    loadRuleGroupsPage(newPage) {
      if (newPage) {
        this.searchPagination.page = newPage;
      }

      this.loadingSearchData = true;
      this.loadingError = false;

      const paramsPage = new URLSearchParams();
      paramsPage.append('page', this.searchPagination.page - 1);
      paramsPage.append('size', this.searchPagination.rowsPerPage);
      paramsPage.append('sort', 'id');

      RuleGroupsService.findRuleGroupsByTermAndUserRole(this.searchTerm, this.userRoleID, paramsPage)
        .then((response) => {
          this.loadingSearchData = false;
          this.ruleGroups = response.data.content;
          this.searchPagination.totalItems = response.data.totalElements;

          this.loadingError = false;
        })
        .catch(() => {
          this.loadingContent = false;
          this.showMessageErro('Ocorreu um erro ao buscar os registros');
          this.ruleGroups = [];
          this.loadingError = true;
        });
    },

    searchDataTableUpdatePage() {
      this.loadRuleGroupsPage();
    },

    searchTermChange() {
      const actualValueTerm = this.searchTerm;
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      const loadBeforeSeconds = async (term, self) => {
        await delay(4000);
        if (term === self.searchTerm) {
          self.loadRuleGroupsPage(1);
        }
      };
      loadBeforeSeconds(actualValueTerm, this);
    },

    newItem() {
      this.editedItem = {
        name: '',
        description: '',
        userRole: this.userRoleID,
        defaults: false,
      };
      this.openDialogItem = true;
      this.editing = false;
    },

    editItem(item) {
      this.editedItem = item;
      this.openDialogItem = true;
      this.editing = true;
    },

    deleteItem(item) {
      this.deletedItem = item;
      this.deleting = true;
    },

    detailItem(item) {
      this.$router.push({ name: 'Rules', params: { groupId: item.id, userRole: this.userRoleID } });
    },

    stopDeletingItem() {
      this.deleting = false;
      this.deletedItem = {};
    },

    confirmItemDeletion(item) {
      this.deleting = false;
      this.loadingContent = true;
      RuleGroupsService.delete(item)
        .then(() => {
          this.loadingContent = false;
          this.loadRuleGroupsPage(1);
        })
        .catch(() => {
          this.showMessageErro('Ocorreu um erro ao excluir o registro');
          this.loadingContent = false;
        });
    },

    closeDialogItem() {
      this.openDialogItem = false;
      this.editedItem = {
        name: '',
        description: '',
        userRole: this.userRoleID,
        defaults: false,
      };
    },

    saveDialogItem(saved) {
      this.loadingContent = true;
      if (this.editing) {
        RuleGroupsService.update(saved)
          .then(() => {
            this.openDialogItem = false;
            this.loadingContent = false;
            this.loadRuleGroupsPage(1);
          })
          .catch(() => {
            this.showMessageErro('Ocorreu um erro ao salvar o registro');
            this.loadingContent = false;
          });
      } else {
        RuleGroupsService.create(saved)
          .then(() => {
            this.openDialogItem = false;
            this.loadingContent = false;
            this.loadRuleGroupsPage(1);
          })
          .catch((error) => {
            this.showMessageErro(error.response.data);
            this.loadingContent = false;
          });
      }
    },

    getUserRoleDescription(userRole) {
      let ruleDescription = '';
      this.allUserRoles.forEach((tr) => {
        if (tr.id === userRole) {
          ruleDescription = tr.value;
        }
      });
      return ruleDescription;
    },
    showMessageErro(message) {
      this.flash(message, 'error', { timeout: 5000 });
    },
  },
};
</script>
<style scoped>
  .tdexpand {
    padding: 10px;
    box-shadow: none;
  }
  .actions {
    display: flex;
  }
</style>
